import React, { Component } from "react";
import _ from "lodash";
import moment from "moment";

import IntelliportCommandsTable from "../components/IntelliportCommandsTable";

import IntelliportCommandsModel from "../components/IntelliportCommandsModel";

import {
    Layout,
    Button,
    Row,
    Col,
    Icon,
    DatePicker,
    message,
    Input,
    Switch,
} from "antd";

class IntelliportCommandsScreen extends Component {
    state = {
        autoReload:
            localStorage.getItem("table_autoReload") !== undefined &&
            localStorage.getItem("table_autoReload") == "true"
                ? true
                : false,
        dataLoading: true,
        searchedTextValue: "",
        dataAll: [],
        data: [],
        dateFrom: moment().startOf("month"),
        dateTo: moment().endOf("day"),
        IntelliportSensorsSettingsFormModalVisible: false,
    };

    intervalId = null;

    onSearchDescription(searchText) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => {
                if (typeof d["sensor_serial_number"] != "undefined") {
                    return d["sensor_serial_number"]
                        .toLowerCase()
                        .includes(searchText.toLowerCase());
                } else {
                    return dataAll;
                }
                if (searchText == "") {
                    return dataAll;
                }
            }),
        });
    }

    componentWillMount() {
        this.loadData(this.state.dateFrom, this.state.dateTo);

        this.intervalId = setInterval(() => {
            if (this.state.autoReload) {
                this.loadData(this.state.dateFrom, this.state.dateTo);
            }
        }, 30000);
    }

    componentWillUnmount() {
        clearInterval(this.intervalId);
    }

    loadData(dateFrom = null, dateTo = null) {
        dateFrom = dateFrom ? dateFrom.format() : null;
        dateTo = dateTo ? dateTo.format() : null;
        this.setState({
            dataLoading: true,
        });
        IntelliportCommandsModel.getAll(dateFrom, dateTo)
            .then((data) => {
                this.setState({
                    dataLoading: false,
                    dataAll: data,
                    data: data,
                });
            })
            .catch(() => {
                message.warning(
                    "Data se nepodařilo načíst. Zkontrolujte spravnou funkčnost služby."
                );
                this.setState({
                    dataLoading: false,
                });
            })
            .then(() => {
                if (this.state.searchedTextValue) {
                    this.onSearchDescription(this.state.searchedTextValue);
                }
            })
    }

    onSearch(searchText) {
        const dataAll = this.state.dataAll;
        this.setState({
            data: _.filter(dataAll, (d) => {
                return d["sensor_serial_number"].startsWith(searchText);
            }),
        });
    }

    onDateRangeChanged(dates, dateStrings) {
        this.setState({
            dateFrom: dates[0],
            dateTo: dates[1],
        });
        this.loadData(dates[0], dates[1]);
    }

    render() {
        return (
            <Layout.Content
                style={{ margin: "24px 16px 0", minHeight: "auto" }}
            >
                <div style={{ padding: 24, background: "#fff" }}>
                    <h2>Intelliport - Příkazy</h2>
                    <div style={{ marginBottom: "20px" }}>
                        <Row>
                            <Col span={16}>
                                <DatePicker.RangePicker
                                    defaultValue={[
                                        this.state.dateFrom,
                                        this.state.dateTo,
                                    ]}
                                    ranges={{
                                        Dnes: [
                                            moment().startOf("day"),
                                            moment().endOf("day"),
                                        ],
                                        Včera: [
                                            moment()
                                                .add(-1, "days")
                                                .startOf("day"),
                                            moment()
                                                .add(-1, "days")
                                                .endOf("day"),
                                        ],
                                        "Poslední týden": [
                                            moment()
                                                .add(-7, "days")
                                                .startOf("day"),
                                            moment().endOf("day"),
                                        ],
                                    }}
                                    allowClear={false}
                                    placeholder={["Od", "Do"]}
                                    format="DD.MM.YYYY HH:mm"
                                    showTime={{ format: "HH:mm" }}
                                    onOk={this.onDateRangeChanged.bind(this)}
                                    style={{ width: 300, marginRight: 10 }}
                                />
                                <Input.Search
                                    placeholder="Najít podle sériového čísla senzoru"
                                    value={this.state.searchedTextValue}
                                    onSearch={this.onSearchDescription.bind(
                                        this
                                    )}
                                    onChange={(e) => {
                                        this.setState({
                                            searchedTextValue: e.target.value,
                                        });
                                    }}
                                    style={{ width: 300 }}
                                />
                            </Col>
                            <Col
                                span={8}
                                offset={0}
                                style={{ textAlign: "right" }}
                            >
                                <Switch
                                    checked={this.state.autoReload}
                                    onChange={(checked) => {
                                        localStorage.setItem(
                                            "table_autoReload",
                                            checked
                                        );
                                        this.setState({
                                            autoReload: checked,
                                        });
                                    }}
                                />{" "}
                                Automatická obnova
                                <Button
                                    type="default"
                                    onClick={() => {
                                        this.loadData(
                                            this.state.dateFrom,
                                            this.state.dateTo
                                        );
                                    }}
                                    style={{ marginInline: 10 }}
                                >
                                    <Icon type="sync" />
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <IntelliportCommandsTable
                        data={this.state.data}
                        loading={this.state.dataLoading}
                        onRowRemoved={(id) => {
                            this.loadData(
                                this.state.dateFrom,
                                this.state.dateTo
                            );
                        }}
                        onAnyFormSuccess={() => {
                            this.loadData(
                                this.state.dateFrom,
                                this.state.dateTo
                            );
                        }}
                    />
                </div>
            </Layout.Content>
        );
    }
}

export default IntelliportCommandsScreen;



// WEBPACK FOOTER //
// ./src/screens/IntelliportCommandsScreen.js